import { Divider, Typography } from '@mui/material';
import { Box } from '@mui/material';

interface Props {
  question: string;
}

const QuestionnaireHeader = ({ question }: Props) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        zIndex: 1,
        minHeight: '80px',
        display: 'flex',
        flexDirection: 'column',
        height: '40px',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          paddingX: 3,
          overflow: 'auto',
          wordBreak: 'break-word',
        }}
      >
        {question}
      </Typography>
      <Divider />
    </Box>
  );
};

export default QuestionnaireHeader;
